import { Typography } from 'antd'
import { AssetImage } from 'features/assetDatabase/components/assetImage/AssetImage'
import { useRolodexEntries } from 'features/rolodex'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import { RolodexEntryType } from 'types'

const TitleBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  background: ${({ theme }) => theme.forecast.background2};
  border-radius: 0.5rem;
`

const TitleIcon = styled.div`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.375rem;
  overflow: hidden;
  flex: 0 0 auto;

  img,
  svg {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
`

const TitleTextWrap = styled.div`
  min-width: 0;
  flex: 1 1 auto;
`

export const NiiDataHealthTitleRow: React.FC<{ unitId: string }> = ({
  unitId,
}) => {
  const { getUnit, getSite } = useRolodexEntries(
    useMemo(
      () => ({
        ids: [unitId],
        links: [RolodexEntryType.SITE],
        type: RolodexEntryType.UNIT,
      }),
      [unitId]
    )
  )

  const { unit, titleText } = useMemo(() => {
    const unit = getUnit(unitId)
    const unitName = unit?.data.name ?? unitId
    const siteId = unit?.tags.site

    const siteName = siteId ? getSite(siteId)?.data.name : undefined
    return {
      unit,
      titleText: siteName ? `${siteName} / ${unitName}` : unitName,
    }
  }, [getUnit, getSite, unitId])

  return (
    <TitleBar>
      <TitleIcon>
        <AssetImage primaryImageID={unit?.data.primary_image} showThumbnail />
      </TitleIcon>
      <TitleTextWrap>
        <Typography.Text strong ellipsis={{ tooltip: titleText }}>
          {titleText}
        </Typography.Text>
      </TitleTextWrap>
    </TitleBar>
  )
}
